import { faCalendarXmark } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a calendar xmark icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/calendar-xmark?f=classic&s=solid
 */
export const CalendarXmarkIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCalendarXmark} {...props} />;
};
